export const messages = {
    "wr-dashboard.search.input.hint": "Търсене",
    "wr-dashboard.search.label.breadcrumb": "Резултати от търсенето",
    "wr-dashboard.search.message.empty": "Няма елементи, които да отговарят на вашето търсене",
    "wr-dashboard.side-bar.selected.title:plural": "{count} избрани елемента | {count} избран елемент | {count} избрани елемента",
    "wr-dashboard.side-bar.backup-type.disk": "Диск",
    "wr-dashboard.side-bar.backup-type.file": "Файл",
    "wr-dashboard.side-bar.backup-type.notarized": "Нотариално заверени файлове и папки",
    "wr-dashboard.side-bar.backup-type.exchange": "Приложение – Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Приложение – Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Приложение – Състояние на системата",
    "wr-dashboard.side-bar.backup-type.application": "Приложение",
    "wr-dashboard.backups-table.column.name": "Име",
    "wr-dashboard.backups-table.column.size": "Размер",
    "wr-dashboard.backups-table.column.version": "Последна версия",
    "wr-dashboard.backups-table.action.delete": "Изтриване",
    "wr-dashboard.backups-table.message.no-backups": "Все още няма архивни копия в облака",
    "wr-dashboard.backups-sidebar.label.size": "Размер",
    "wr-dashboard.backups-sidebar.label.type": "Тип",
    "wr-dashboard.backups-sidebar.label.version": "Последна версия",
    "wr-dashboard.backups-sidebar.label.created": "Създадено",
    "wr-dashboard.backups-sidebar.label.machine": "Машина",
    "wr-dashboard.backups-sidebar.label.owner": "Собственик",
    "wr-dashboard.content-table.column.name": "Име",
    "wr-dashboard.content-table.column.versions": "Версии",
    "wr-dashboard.content-table.column.volumes": "Томове",
    "wr-dashboard.content-table.column.path": "Път",
    "wr-dashboard.content-table.column.size": "Размер",
    "wr-dashboard.content-table.column.version": "Последна версия",
    "wr-dashboard.content-table.action.notary-verify": "Проверка",
    "wr-dashboard.content-table.action.notary-get-crt": "Получаване на сертификат",
    "wr-dashboard.content-table.action.asign": "Изпращане за подпис",
    "wr-dashboard.content-table.action.versions": "Версии",
    "wr-dashboard.content-table.action.restore": "Изтегляне",
    "wr-dashboard.content-table.label.size": "Размер",
    "wr-dashboard.content-table.label.created": "Създадено",
    "wr-dashboard.content-table.label.modified": "Променено",
    "wr-dashboard.content-table.message.empty-folder": "Тази папка е празна",
    "wr-dashboard.password-dialog-box.title.backup": "Криптирано архивно копие",
    "wr-dashboard.password-dialog-box.title.archive": "Криптиран архив",
    "wr-dashboard.password-dialog-box.message.backup": "Посочете паролата за достъп до архивното копие {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Посочете паролата за достъп до архива {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Парола",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Паролата е неправилна",
    "wr-dashboard.form.button.open": "Отваряне",
    "wr-dashboard.form.button.close": "Затваряне",
    "wr-dashboard.form.button.cancel": "Отказ",
    "wr-dashboard.form.button.continue": "Продължаване",
    "wr-dashboard.form.button.proceed": "Продължаване",
    "wr-dashboard.form.button.delete": "Изтриване",
    "wr-dashboard.form.button.done": "Готово",
    "wr-dashboard.form.button.retry": "Повторен опит",
    "wr-dashboard.notary.verify.view.status.downloading": "Изтегляне...",
    "wr-dashboard.notary.verify.view.status.validating": "Валидиране...",
    "wr-dashboard.notary.verify.view.status.pending": "Изчаква се сертификат...",
    "wr-dashboard.notary.verify.view.status.fail": "Несъответствие на сертификата...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Получаване на сертификат",
    "wr-dashboard.notary.verify.view.file-info.name": "ИМЕ",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "ПОДПИСАН ОТ",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "ДАТА НА АРХИВИРАНЕ",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "ДАТА НА НОТАРИАЛНА ЗАВЕРКА",
    "wr-dashboard.notary.verify.view.button.cancel": "Отказ",
    "wr-dashboard.notary.verify.view.button.done": "Готово",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Неподдържана версия на браузъра",
    "wr-dashboard.versions-dialog-box.title": "Версии на {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Изпращане за подпис",
    "wr-dashboard.asign-dialog-box.message": "Версията на файла е споделена, но никой няма да може да вижда файла без връзката към него. Продължете към ASign, за да добавите подписващи лица и да споделите връзката.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Показване на подробни данни за файл",
    "wr-dashboard.page-not-found.title": "Страницата не е открита",
    "wr-dashboard.page-not-found.message.main": "Страницата, която търсите, не е намерена.",
    "wr-dashboard.page-not-found.message.description": "Връзката може да е остаряла или може да сте въвели адреса неправилно.",
    "wr-dashboard.page-not-found.message.error": "Код на грешка: 404",
    "wr-dashboard.server-error.title": "Сървърът не е достъпен",
    "wr-dashboard.server-error.message": "В момента сървърът не е достъпен. Опитайте отново по-късно.",
    "wr-dashboard.server-error.message.error": "Код на грешка: 500",
    "wr-dashboard.account-menu.action.sign-out": "Изход",
    "wr-dashboard.breadcrumb.item.machines": "Машини",
    "wr-dashboard.breadcrumb.item.failed-backups": "Неуспешни архивни копия",
    "wr-dashboard.machines-table.column.name": "Име",
    "wr-dashboard.machines-table.column.size": "Размер",
    "wr-dashboard.machines-table.message.no-machines": "Все още няма машини в облака",
    "wr-dashboard.incomplete-backups.message.status:plural": "Имате {count} неуспешни или непълни архивни копия, заемащи {size} място за съхранение | Имате {count} неуспешни или непълно архивно копие, заемащи {size} място за съхранение | Имате {count} неуспешни или непълни архивни копия, заемащи {size} място за съхранение",
    "wr-dashboard.incomplete-backups.button.view": "Преглед на архивни копия",
    "wr-dashboard.incomplete-backups.button.delete": "Изтриване на архивни копия",
    "wr-dashboard.machines-table.message.space-used:plural": "Общо използване от архивните копия {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Изтриване на архиви",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Изтриване на незавършени архиви",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Изтриване на всички незавършени архиви",
    "wr-dashboard.delete-archive.message": "Наистина ли искате да изтриете окончателно избраните архиви от всички местоположения? Всички данни ще бъдат изтрити и не могат да бъдат възстановени.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Сертификатът е в изчакване",
    "wr-dashboard.certificate-pending-dialog-box.message": "Опитайте отново след няколко минути.",
    "wr-dashboard.form.button.ok": "Ok"
};
